import { CriticalType, ProjectType } from './types';
import { addYears } from 'date-fns';
import Joi from 'joi';

export const projectValidation = (startDate, endDate, projectDuplicated) => {
  const relationshipStart = startDate ? new Date(startDate) : new Date();
  const relationshipEnd = endDate ? new Date(endDate) : addYears(new Date(), 77);

  return Joi.object({
    clientName: Joi.string()
      .regex(/^[a-zA-Z0-9ñáéíóúüÁÉÍÓÚÜ'&-/ ]*$/)
      .messages({
        'any.required': 'Este campo es requerido',
        'string.empty': 'Este campo es requerido',
        'string.pattern.base': 'El nombre debe contener solo letras y numeros',
      })
      .required(),

    projectName: Joi.string()
      .min(3)
      .max(35)
      .regex(/^[a-zA-Z0-9ñáéíóúüÁÉÍÓÚÜ'&-/ ]*$/)
      .custom((value, helper) => {
        if (value && Boolean(projectDuplicated)) return helper.error('any.invalid');
      })
      .trim()
      .messages({
        'any.required': 'Este campo es requerido',
        'string.min': 'El nombre debe contener al menos 3 caracteres',
        'string.max': 'El nombre no debe contener más de 35 caracteres',
        'string.empty': 'Este campo es requerido',
        'string.pattern.base': 'El nombre debe contener solo letras y numeros',
        'any.invalid': 'Ya existe un proyecto con el mismo nombre',
      })
      .required(),

    description: Joi.string()
      .max(100)
      .custom((value, helpers) => {
        if (!value.trim()) {
          return helpers.error('string.empty');
        }
        if (value.trim() !== value) {
          return helpers.error('string.trim');
        }
        return value;
      }, 'custom validation')
      .messages({
        'string.max': 'La descripción no debe contener más de 100 caracteres',
        'string.empty': 'La descripción no puede estar vacía o contener solo espacios',
        'string.trim': 'La descripción no puede contener espacios al principio o al final',
      })
      .allow(''),

    notes: Joi.string()
      .max(100)
      .custom((value, helpers) => {
        if (!value.trim()) {
          return helpers.error('string.empty');
        }
        if (value.trim() !== value) {
          return helpers.error('string.trim');
        }
        return value;
      }, 'custom validation')
      .messages({
        'string.max': 'La nota no debe contener más de 100 caracteres',
        'string.empty': 'La nota no puede estar vacía o contener solo espacios',
        'string.trim': 'La nota no puede contener espacios al principio o al final',
      })
      .allow('')
      .options({ convert: true }),

    startDate: Joi.date()
      .min(relationshipStart)
      .max(relationshipEnd)
      .messages({
        'date.min': 'Fecha invalida. Revisar fechas del Cliente',
        'date.max': 'Fecha invalida. Revisar fechas del Cliente',
        'date.required': 'Este campo es requerido.',
        'date.base': 'Formato de fecha inválido. Debe ser DD/MM/AAAA',
      })
      .allow(null)
      .required(),

    endDate: Joi.date()
      .min(Joi.ref('startDate'))
      .max(relationshipEnd)
      .messages({
        'date.min': 'Fecha invalida. Revisar fechas del Cliente',
        'date.max': 'Fecha invalida. Revisar fechas del Cliente',
        'date.base': 'Formato de fecha inválido. Debe ser DD/MM/AAAA',
      })
      .allow(null),

    isCritic: Joi.string()
      .valid(CriticalType.ALTA, CriticalType.MEDIA, CriticalType.BAJA)
      .messages({
        'any.only': 'La criticidad debe ser Alta, Media o Baja',
        'any.required': 'Este campo es requerido',
      })
      .required(),

    projectType: Joi.string()
      .valid(ProjectType.PRODUCT_BUILDING, ProjectType.STAFF_AUGMENTATION)
      .required()
      .messages({
        'any.only': 'El tipo de proyecto debe ser Product Building o Staff Augmentation',
        'any.required': 'Este campo es requerido',
      }),
  }).options({ allowUnknown: true });
};
